export { default } from './AuthNextSeo';
